var map = {
	"./events_activism_blue.png": "228b",
	"./events_allinfo_blue.png": "ae84",
	"./events_assault_blue.png": "eb12",
	"./events_attempt_blue.png": "2529",
	"./events_conflict_blue.png": "885f",
	"./events_crime_blue.png": "eadb",
	"./events_disasters_blue.png": "9434",
	"./events_elections_blue.png": "c30c",
	"./events_general_blue.png": "3106",
	"./events_health_blue.png": "4c45",
	"./events_hijack_blue.png": "45a9",
	"./events_insult_blue.png": "5be9",
	"./events_kidnap_blue.png": "a0df",
	"./events_maritime_terrorism_blue.png": "811e",
	"./events_political_terrorism_blue.png": "0a7b",
	"./events_robbery_blue.png": "2c03",
	"./events_state_action_blue.png": "b2c0",
	"./events_suspicious_activity_blue.png": "b867",
	"./events_terrorism_blue.png": "fad1",
	"./events_theft_blue.png": "4155",
	"./events_threat_blue.png": "576b",
	"./events_toc_blue.png": "b10b",
	"./events_transportation_blue.png": "97d4",
	"./events_travel_blue.png": "851a",
	"./events_unrest_blue.png": "5396",
	"./events_war_blue.png": "d0e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "71c2";